import { render, staticRenderFns } from "./Demos.vue?vue&type=template&id=129ad971&scoped=true&"
import script from "./Demos.vue?vue&type=script&lang=js&"
export * from "./Demos.vue?vue&type=script&lang=js&"
import style0 from "./Demos.vue?vue&type=style&index=0&id=129ad971&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ad971",
  null
  
)

export default component.exports